import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import RolesList from './RolesList';

//redux

const Roles = () => {
	const breadcrumbLinks = [{ to: '#', label: 'Inicio', icon: 'icon-house' }];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Perfiles' links={breadcrumbLinks} icon={'icon-id-card'} />
					<RolesList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Roles;
